var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-container',{staticClass:"bock--background",attrs:{"fluid":""}},[_c('i-row',[_c('i-column',{staticClass:"_display-flex _justify-content-center _align-items-center"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }